/**
 * Regras de apresentação da tela de Seguro de Carga (puras, testáveis).
 * O cálculo mora na API; aqui só formata.
 */
import type { CargoInsuranceClaimDto } from "@bi/types";

/** "R$ 300 mil", "R$ 1,5 mi" — para frases e cartões. */
export function moneyShort(v: number): string {
  const a = Math.abs(v);
  const sign = v < 0 ? "−" : "";
  if (a >= 1_000_000) return `${sign}R$ ${(a / 1_000_000).toLocaleString("pt-BR", { maximumFractionDigits: 2 })} mi`;
  if (a >= 1_000) return `${sign}R$ ${(a / 1_000).toLocaleString("pt-BR", { maximumFractionDigits: a >= 100_000 ? 0 : 1 })} mil`;
  return `${sign}R$ ${Math.round(a).toLocaleString("pt-BR")}`;
}

/** Fração → percentual curto com a precisão que o seguro pede (0,054%). */
export function pctShort(fraction: number | null): string {
  if (fraction == null) return "—";
  return `${(fraction * 100).toLocaleString("pt-BR", { maximumFractionDigits: 3 })}%`;
}

/** "28/02/2026" a partir de um ISO; usa o fuso de SP (vigências e sinistros são instantes reais). */
export function dateSp(iso: string | null): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("pt-BR", { timeZone: "America/Sao_Paulo" });
}

export const CLAIM_STATUS: Record<CargoInsuranceClaimDto["status"], string> = {
  aberto: "Em aberto", indenizado: "Indenizado", negado: "Negado",
};

/** Quanto ficou com a transportadora: prejuízo menos o indenizado. Negado e em aberto ficam com o prejuízo todo. */
export function claimNetLoss(c: Pick<CargoInsuranceClaimDto, "lossValue" | "indemnityValue">): number | null {
  if (c.lossValue == null) return null;
  return Math.max(0, c.lossValue - (c.indemnityValue ?? 0));
}
